import React from 'react';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';

const AnchorLink = styled('a')`
  font-size: 14px;
  color: #000;
  text-decoration: none;
  margin-top: 10px;
  background-color: #0e3a23;
  color: #fff;
  padding: 8px 18px;
  display: inline-block;
  margin-top: 10px;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 600;
  cursor: pointer;
`;
export const GmfProductSummary = ({ sku }) => {
  return (
    <div>
      <div class="gmf-review-summary" data-product-id={sku}></div>
      <AnchorLink href={'#gmf-comment-section'}>{t('View reviews')}</AnchorLink>
    </div>
  );
};
